import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const leftContentRightImg = ({data}) => {
  return (
    <>
      <Container>
        <Row className="align-items-center my-5 p-0 p-md-3 border border-dark rounded-5">
          <Col md={6} className="pt-md-0 pt-2">
            <h2 className="fs-48">{data.sectionName}</h2>
            <p className="fs-38 fst-italic">{data.parapgraphItalic}</p>
            <p>
              {data.sectionparagraphText}
            </p>

            <Row>
            <h2 className="fs-30">{data.categoryHeadingLeftSide}</h2>
            {data.CategoriesLeftContent?.map((item, index)=>(
               <Col md={4} key={index} className="col-4">
               <img className="img-fluid rounded" loading="lazy" src={item.CategoryImg}/>
               <p className="text-center fw-normal mt-1 fs-14">
                  {item.CategoryName}
               </p>
           </Col>

            ))}
            <Row>
              <Col md={12}>
                    {data.ListContent?.map((item, index) => (
                        <Col md={12} className="mt-1">
                          <ul>
                            <li className="">
                              <b key={index}>{item.ListHeading} </b>
                              <br></br>
                              {item.ListParagraph}
                            </li>
                          </ul>
                        </Col>
                      ))}
              </Col>
            </Row>
           
            
        </Row>
          </Col>
          <Col md={6} className="p-0 m-0">
            <div>
              <img
                src={data.ImgSrc}
                className="rounded-5 img-fluid"
                loading="lazy"
                id="leftContentRightImg"
              />
            </div>
          </Col>
          
        </Row>
        
      </Container>
    </>
  );
};

export default leftContentRightImg;
